import React, { useRef , useEffect, useState} from "react";
import Row from "./Row";
import {Box, useTheme} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

const DrawingPanel = (props) =>  {

  const {height, width ,selectedFrame} = props;
  const theme = useTheme()

  const panelRef = useRef();

  let rows = [];

  console.log("Draw frame: ", selectedFrame);
  const [realPixelSize, setrealPixelSize] = useState();

  for (let i = 0; i < height; i++) {
    rows.push(<Row key={i} row={i} width = {width} pixelSize = {realPixelSize}/>);
  }

  

  //debugger;



  const handleElementResized = () => {

    let availableWidth = panelRef.current.offsetWidth - 2;

    let pixelSize = Math.floor(availableWidth/width)

    setrealPixelSize(pixelSize); 
    console.log("Pix:" , pixelSize)
    
    
  };

  const resizeObserver = new ResizeObserver(handleElementResized);


  useEffect(() => {
    // the code in useEffect will be executed when the component
    // has mounted, so we are certain observedDiv.current will contain
    // the div we want to observe
    resizeObserver.observe(panelRef.current);


    // if useEffect returns a function, it is called right before the
    // component unmounts, so it is the right place to stop observing
    // the div
    return function cleanup() {
      resizeObserver.disconnect();
    }
  });


  return (

    <>
    <Box 
          ref={panelRef} 
          display = "flex"
          width = "100%"
      >
      <Box 
          display = "flex"
          flexDirection = "column"
          sx={{border: `1px solid ${theme.palette.primary.main}`}}
      >
          {rows}
      </Box>
      </Box>
    </>
  );
}

export default DrawingPanel;